import React from "react";
import { useSite } from "../context/SiteContext";

export default function Hero() {
  const { c } = useSite();
  const { hero } = c;
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="top" className="relative min-h-screen flex items-center grain overflow-hidden">
      <div className="absolute inset-0">
        <img src={hero.image} alt="Misty Harz forest" className="w-full h-full object-cover animate-kenburns" />
        <div className="absolute inset-0 bg-gradient-to-b from-[rgba(18,15,11,0.7)] via-[rgba(18,15,11,0.4)] to-[rgba(18,15,11,0.96)]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[rgba(18,15,11,0.75)] to-transparent" />
      </div>

      <div className="relative max-w-[1220px] mx-auto px-5 sm:px-8 w-full pt-36 pb-24">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-8">
            <span className="eyebrow">{hero.eyebrow}</span>
          </div>
          <p className="text-lg sm:text-2xl leading-relaxed text-[#EFE7D6]/80 max-w-2xl font-light">
            {hero.text}
          </p>
          <div className="mt-11 flex flex-wrap items-center gap-6">
            <button
              onClick={() => go("origins")}
              className="font-label text-[0.72rem] uppercase tracking-[0.22em] text-ink bg-gold px-8 py-4 hover:opacity-90 transition-opacity duration-300"
            >
              {hero.ctaPrimary}
            </button>
            <button
              onClick={() => go("gathering")}
              className="font-label text-[0.72rem] uppercase tracking-[0.22em] text-[#EFE7D6] underline underline-offset-8 decoration-gold/60 hover:text-gold transition-colors duration-300"
            >
              {hero.ctaSecondary}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
